import { useQuery } from '@tanstack/react-query';

import { taxpayerService } from '../services/taxpayer.service';

export const useTaxpayerRecent = () => {
  return useQuery({
    queryKey: ['taxpayer-recent'],
    queryFn: () => taxpayerService.listMostRecentTaxpayers()
  });
};
